module.exports = __webpack_public_path__ + "img/color_block_8.6b8a11c6.svg";